import { useQueries } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ReviewAnalysisApiService } from 'src/services/reviewAnalysisApi'
import { Facility } from 'src/services/reviewAnalysisApi/interfaces/reviewAnalysis.interface'

interface UseGetReviewCampaignFacilitiesParams {
  campaignIds: string[]
  enabled?: boolean
}

// Maps each review-analysis campaign id to its facilities (locations). The
// campaign list endpoint never populates facilities, so they are read from each
// campaign's /overview response (facility.id matches review.facilityId).
export const useGetReviewCampaignFacilities = ({
  campaignIds,
  enabled = true,
}: UseGetReviewCampaignFacilitiesParams): Record<string, Facility[]> => {
  const results = useQueries({
    queries: campaignIds.map((campaignId) => ({
      enabled: enabled && !!campaignId,
      queryFn: () => ReviewAnalysisApiService.getOverview(campaignId),
      queryKey: [QueryKey.GET_REVIEW_ANALYSIS_OVERVIEW, campaignId, '', ''],
      staleTime: 5 * 60 * 1000,
    })),
  })

  return campaignIds.reduce<Record<string, Facility[]>>(
    (acc, campaignId, index) => {
      acc[campaignId] = results[index]?.data?.facilities ?? []
      return acc
    },
    {}
  )
}
